// tus glue for the /presentations/{id} upload widget. Reloads the
// page on success so the server-rendered card flips to processing.

import {
  tusUpload,
  formatBytes,
  throttleByIntegerPercent,
} from "./presentation_tus.js";
import { onceGuard } from "./bind_once.js";

const firstBind = onceGuard();

const ROOT_SELECTOR = "[data-presentation-upload]";
const INPUT_SELECTOR = "[data-presentation-upload-input]";
const STATUS_SELECTOR = "[data-presentation-upload-status]";
const BAR_SELECTOR = "[data-presentation-upload-bar]";
const MESSAGE_SELECTOR = "[data-presentation-upload-message]";

export function initPresentationUpload(root = document) {
  const widgets = root.querySelectorAll
    ? root.querySelectorAll(ROOT_SELECTOR)
    : [];
  widgets.forEach(wireWidget);
}

function wireWidget(el) {
  if (!firstBind(el)) return;

  const uploadURL = el.dataset.uploadUrl;
  if (!uploadURL) return;

  const input = el.querySelector(INPUT_SELECTOR);
  if (!input) return;

  const status = el.querySelector(STATUS_SELECTOR);
  const bar = el.querySelector(BAR_SELECTOR);
  const message = el.querySelector(MESSAGE_SELECTOR);

  input.addEventListener("change", () => {
    const file = input.files && input.files[0];
    if (!file) return;

    showStatus(status, message, "Starting upload…");
    input.disabled = true;

    tusUpload({
      file,
      uploadURL,
      onError: (err) => {
        console.error("presentations.upload: tus upload failed", err);
        input.disabled = false;
        input.value = "";
        setMessage(message, "Upload failed. Refresh to try again.");
      },
      onProgress: throttleByIntegerPercent((bytesUploaded, bytesTotal, pct) => {
        if (bar) bar.style.width = `${pct}%`;
        setMessage(
          message,
          `Uploading ${formatBytes(bytesUploaded)} of ${formatBytes(bytesTotal)} (${pct}%)`,
        );
      }),
      onSuccess: () => {
        if (bar) {
          bar.style.width = "100%";
          bar.classList.remove("bg-brand-500");
          bar.classList.add("bg-emerald-500");
        }
        setMessage(message, "Upload complete. Your video is being processed…");
        // Reload so the server-rendered card flips to the processing
        // state, which carries its own polling.
        setTimeout(() => window.location.reload(), 600);
      },
    });
  });
}

function showStatus(status, message, text) {
  if (status) status.classList.remove("hidden");
  setMessage(message, text);
}

function setMessage(node, text) {
  if (node) node.textContent = text;
}
